"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeSessionsResponse = exports.ChargeSession = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class ChargeSession extends base_models_1.Serializable {
}
exports.ChargeSession = ChargeSession;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2030-07-31T13:01:22Z',
        description: 'Start date',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "startDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2030-07-31T17:12:51Z',
        description: 'End date',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "endDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 368,
        description: 'Duration of the charge session in seconds',
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Number)
], ChargeSession.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 1.32,
        description: 'Charged volume in kWh',
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Number)
], ChargeSession.prototype, "volume", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 20.44,
        description: 'Total cost of a charge session',
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Number)
], ChargeSession.prototype, "totalCost", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'NL1234324',
        description: 'ID of charge point used',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "chargePointId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'NLVDB',
        description: 'ID of the Charge Point Operator',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "cpoId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'Location of charging session',
        description: 'Willemsplein 4',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "fullAddress", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: "'S-HERTOGENBOSCH",
        description: 'City name',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "city", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'Netherlands',
        description: 'Country name',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeSession.prototype, "country", void 0);
class ChargeSessionsResponse extends base_models_1.Serializable {
}
exports.ChargeSessionsResponse = ChargeSessionsResponse;
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ChargeSession),
    tslib_1.__metadata("design:type", Array)
], ChargeSessionsResponse.prototype, "results", void 0);
